<template>
  <template v-if="uid === 'biennial-entry'">
    <search-hits-hit-biennial-component
      :hit="hit"
      :key="hit?.slug"
    />
  </template>
  <template v-else-if="uid === 'education-entry'">
    <search-hits-hit-education-component
      :hit="hit"
      :key="hit?.slug"
    />
  </template>
  <template v-else-if="uid === 'news-entry'">
    <search-hits-hit-news-component
      :hit="hit"
      :key="hit?.slug"
    />
  </template>
  <template v-else-if="uid === 'publication-entry'">
    <search-hits-hit-publication-component
      :hit="hit"
      :key="hit?.slug"
    />
  </template>
  <template v-else-if="uid === 'urban-vision-entry'">
    <search-hits-hit-urban-vision-component
      :hit="hit"
      :key="hit?.slug"
    />
  </template>
  <template v-else-if="uid === 'biennial-participant-entry'">
    <search-hits-hit-participant-component
      :hit="hit"
      :key="hit?.slug"
    />
  </template>
  <template v-else>
    <layout-animated-underline-component
      :to="routeObject"
      :class="$style.link"
      :key="hit?.slug"
      :data-current="linkActive(routeObject) ? '' : null"
    >
      <template #default>
        <span v-html="hitData?.title" />
      </template>
    </layout-animated-underline-component>
  </template>
</template>

<script setup>
  const localePath = useLocalePath()
  const route = useRoute()

  const props = defineProps({
    hit: Object,
    uid: String
  })

  const hitData = computed(() => {
    return props?.hit?._formatted || props?.hit
  })

  const routeObject = computed(() => {
    return baseRouteGetObject(
      getStrapiRouteReference(props?.uid)?.name,
      props?.hit?.slug
    )
  })

  const linkActive = (routeObject) => {
    if (!routeObject) return false
    if (!routeObject.path) return false
    const path = localePath(routeObject)
    return route.path === path
  }
</script>

<style module>
.link {
  composes: reset-link font-size-medium from global;
}

.link mark {
  background-color: transparent;
  color: inherit;
}
</style>
